var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInApp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4421_23196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9757 10.7857C19.0783 10.7042 19.2308 10.7805 19.2308 10.9093V16.286C19.2308 16.9828 18.6655 17.5481 17.9687 17.5481H7.03125C6.33451 17.5481 5.76923 16.9828 5.76923 16.286V10.9119C5.76923 10.7805 5.91909 10.7069 6.02426 10.7884C6.61321 11.2458 7.39408 11.8269 10.0759 13.7751C10.6306 14.18 11.5666 15.0319 12.5 15.0266C13.4386 15.0345 14.393 14.1643 14.9268 13.7751C17.6085 11.8269 18.3868 11.2432 18.9757 10.7857ZM12.5 14.1827C13.11 14.1932 13.9881 13.4149 14.4298 13.0942C17.9188 10.5623 18.1843 10.3414 18.9889 9.71039C19.1414 9.59208 19.2308 9.40803 19.2308 9.21347V8.71392C19.2308 8.01718 18.6655 7.4519 17.9687 7.4519H7.03125C6.33451 7.4519 5.76923 8.01718 5.76923 8.71392V9.21347C5.76923 9.40803 5.85862 9.58945 6.01112 9.71039C6.81565 10.3388 7.0812 10.5623 10.5702 13.0942C11.0119 13.4149 11.89 14.1932 12.5 14.1827Z",
    fill: "#132439"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4421_23196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(5.76923 5.76929)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInApp);
export default __webpack_public_path__ + "static/media/in_app.9de407c62540431edb53f60aac24e4ab.svg";
export { ForwardRef as ReactComponent };